<div class="departure">
  <div class="departure__header">Departure</div>
  <ul class="sgl-timeline">
    @for (departure of dates; track departure.label) {
      <li class="sgl-timeline__item">
        <div class="departure__label">{{ departure.label }}</div>
        <span>{{ departure.value | dateTimeFormat }}</span>
      </li>
    }
  </ul>
</div>
